import type { MenuLink } from '../types';

export const businessLinks: MenuLink[] = [
  { label: 'For business', path: 'business', corePage: true },
  { label: 'Partner directory', path: 'partners' },
  { label: 'For accountants', path: 'accountants' },
  { label: 'For advisors', path: 'financial-advisers' },
  { label: 'For SMSFs', path: 'smsf' },
];
